/*
=========================================================
* Material Kit 2 React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Material Kit 2 React examples
import DefaultNavbar from "bachrosenComponents/bachNavbar";
import CenteredFooter from "bachrosenComponents/centeredFooter";
import BachHeader from "bachrosenComponents/bachHeader";
// import HorizontalBlogCard from "examples/Cards/BlogCards/HorizontalBlogCard";

// Routes
import routes from "routes";
import footerRoutes from "footer.routes";

// Images
import bgImage from "assets/images/home1.jpg";

function HonorarySite() {
  const obrist = `
    2012 - Erwin Klotz
  `;
  const dackelorden = `
    2017 - Kurt Müller <br>
    2015 - Gisela Müller <br>
    2007 - Manfred Klotz <br>
    1999 - Albert Farischon <br>
  `;
  // Verstorbene:
  // 1993 - Siegfried König

  const silberNadel = `
    2013 - Franz Bertsche <br>
    2007 - Albert Farischon
  `;

  const ehrenpräsident = `
  2022 - Kurt Müller <br>
  2022 - Johann Beppler <br>
  Erwin Klotz <br>
  `;

  const ehrenmitglied = `
  Franz Bertsche <br>
  Manfred Erne <br>
  Ewald Beppler <br>
  Gisela Müller <br>
  Karl Traber <br>
  Albert Farischon <br>
  Manfred Klotz <br>
`;

  return (
    <>
      <MKBox position="fixed" top="0.5rem" width="100%">
        <DefaultNavbar routes={routes} dark info center />
      </MKBox>
      <BachHeader image={bgImage} title="Ehrentafel" />
      {/* <MKBox
        minHeight="75vh"
        width="100%"
        sx={{
          backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
            `${linearGradient(
              rgba(gradients.dark.main, 0.6),
              rgba(gradients.dark.state, 0.6)
            )}, url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "grid",
          placeItems: "center",
        }}
      >
        <MKTypography
          align="center"
          variant="h1"
          color="white"
          sx={({ breakpoints, typography: { size } }) => ({
            [breakpoints.down("md")]: {
              fontSize: size["3xl"],
            },
          })}
        >
          Ehrentafel
        </MKTypography>
      </MKBox> */}

      <Card
        sx={{
          // p: 2,
          mx: { xs: 2, lg: 3 },
          mt: -8,
          mb: 4,
          pt: 4,
          pb: 4,
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        <Container>
          <MKBox borderRadius="lg" p={2} pl={5} mx={2} bgColor="white" shadow="lg">
            <MKTypography variant="h5" color="secondary" mt={4}>
              Obrist der Narrenvereinigung Hegau-Bodensee
            </MKTypography>
            <MKTypography
              variant="body2"
              color="text"
              mb={3}
              dangerouslySetInnerHTML={{ __html: obrist }}
            />
            <MKTypography variant="h5" color="secondary" mt={4}>
              Dackelorden
            </MKTypography>
            <MKTypography
              variant="body2"
              color="text"
              mb={3}
              dangerouslySetInnerHTML={{ __html: dackelorden }}
            />
            <MKTypography variant="h5" color="secondary" mt={4}>
              Silberne Ehrennadel der Narrenvereinigung Hegau-Bodensee
            </MKTypography>
            <MKTypography
              variant="body2"
              color="text"
              mb={3}
              dangerouslySetInnerHTML={{ __html: silberNadel }}
            />
            <MKTypography variant="h5" color="secondary" mt={4}>
              Ehrenpräsident
            </MKTypography>
            <MKTypography
              variant="body2"
              color="text"
              mb={3}
              dangerouslySetInnerHTML={{ __html: ehrenpräsident }}
            />
            <MKTypography variant="h5" color="secondary" mt={4}>
              Ehrenmitglied
            </MKTypography>
            <MKTypography
              variant="body2"
              color="text"
              mb={3}
              dangerouslySetInnerHTML={{ __html: ehrenmitglied }}
            />
          </MKBox>

          {/* <Grid container spacing={3} mb={4}>
            <Grid item xs={12} lg={12}>
              <MKBox mb={1}>
                <MKBox
                  bgColor="white"
                  borderRadius="xl"
                  shadow="lg"
                  display="flex"
                  flexDirection="column"
                  justifyContent="center"
                  mt={{ xs: 10, sm: 9, md: 10 }}
                  mx={1}
                >
                  <MKBox
                    variant="gradient"
                    bgColor="success"
                    coloredShadow="success"
                    borderRadius="lg"
                    p={2}
                    mx={2}
                    mt={-3}
                  >
                    <MKTypography variant="h3" color="white">
                      Obrist der Narrenvereinigung Hegau-Bodensee
                    </MKTypography>
                  </MKBox>
                  <MKBox p={3}>
                    <MKTypography
                      variant="body2"
                      color="text"
                      mb={3}
                      dangerouslySetInnerHTML={{ __html: obrist }}
                    />
                  </MKBox>
                </MKBox>
              </MKBox>
            </Grid>
            <Grid item xs={12} lg={12}>
              <MKBox mb={1}>
                <MKBox
                  bgColor="white"
                  borderRadius="xl"
                  shadow="lg"
                  display="flex"
                  flexDirection="column"
                  justifyContent="center"
                  mt={{ xs: 10, sm: 9, md: 10 }}
                  mx={1}
                >
                  <MKBox
                    variant="gradient"
                    bgColor="success"
                    coloredShadow="success"
                    borderRadius="lg"
                    p={2}
                    mx={2}
                    mt={-3}
                  >
                    <MKTypography variant="h3" color="white">
                      Dackelorden
                    </MKTypography>
                  </MKBox>
                  <MKBox p={3}>
                    <MKTypography
                      variant="body2"
                      color="text"
                      mb={3}
                      dangerouslySetInnerHTML={{ __html: dackelorden }}
                    />
                  </MKBox>
                </MKBox>
              </MKBox>
            </Grid>
            <Grid item xs={12} lg={12}>
              <MKBox mb={1}>
                <MKBox
                  bgColor="white"
                  borderRadius="xl"
                  shadow="lg"
                  display="flex"
                  flexDirection="column"
                  justifyContent="center"
                  mt={{ xs: 10, sm: 9, md: 10 }}
                  mb={{ xs: 10, sm: 9, md: 10 }}
                  mx={1}
                >
                  <MKBox
                    variant="gradient"
                    bgColor="success"
                    coloredShadow="success"
                    borderRadius="lg"
                    p={2}
                    mx={2}
                    mt={-3}
                  >
                    <MKTypography variant="h3" color="white">
                      Silberne Ehrennadel der Narrenvereinigung Hegau-Bodensee
                    </MKTypography>
                  </MKBox>
                  <MKBox p={3}>
                    <MKTypography
                      variant="body2"
                      color="text"
                      mb={3}
                      dangerouslySetInnerHTML={{ __html: silberNadel }}
                    />
                  </MKBox>
                </MKBox>
              </MKBox>
            </Grid>
          </Grid> */}
        </Container>
      </Card>
      <MKBox px={1} mt={6}>
        <CenteredFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

export default HonorarySite;
